module.exports = __webpack_public_path__ + "static/media/web logos_Team GB_colour.3dbae80d.jpg";